import { render, staticRenderFns } from "./filter-btn.vue?vue&type=template&id=967a4818&scoped=true&"
import script from "./filter-btn.vue?vue&type=script&lang=js&"
export * from "./filter-btn.vue?vue&type=script&lang=js&"
import style0 from "./filter-btn.vue?vue&type=style&index=0&id=967a4818&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967a4818",
  null
  
)

export default component.exports